/* Five Origins — The Sixt Pack configurator
   Fără dependențe. Datele vin din #fsp-data (randate de Liquid din catalogul live). */
(function () {
  'use strict';

  var root = document.querySelector('[data-fsp]');
  if (!root) return;

  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('fsp-data').textContent) || {}; } catch (e) { return; }
  var ITEMS = DATA.items || [];
  var GRAMS = (DATA.opts && DATA.opts.g) || [];
  var GRINDS = (DATA.opts && DATA.opts.m) || [];
  var CFG = DATA.cfg || {};
  var SLOTS = CFG.slots || 6;
  var D1 = CFG.d1 || 10, D2 = CFG.d2 || 15;
  var C1 = CFG.c1 || '', C2 = CFG.c2 || '';
  var BOX = CFG.box || null;
  var MODE = CFG.mode === 'gift' ? 'gift' : 'pack';
  var G500 = Math.max(0, GRAMS.indexOf('500 gr'));
  var GBEANS = Math.max(0, GRINDS.indexOf('Boabe Întregi'));
  if (!ITEMS.length) return;

  /* normalizare variante: vs = [[id, gramaj, macinare, pret], ...] -> v[g][m], p[g] */
  ITEMS.forEach(function (it) {
    var v = [], p = [], gi, mi;
    for (gi = 0; gi < GRAMS.length; gi++) { v.push([]); p.push(0); }
    (it.vs || []).forEach(function (r) {
      gi = GRAMS.indexOf(r[1]); mi = GRINDS.indexOf(r[2]);
      if (gi < 0 || mi < 0) return;
      v[gi][mi] = r[0];
      if (!p[gi]) p[gi] = r[3];
    });
    it.v = v; it.p = p; it.vs = null;
  });

  /* ---------- stare ---------- */
  var pack = [];                       // {i: index în ITEMS, g: idx gramaj, m: idx măcinare}
  var gGram = G500, gGrind = GBEANS;   // implicite globale
  var filter = 'all';
  /* Coffee Finder trimite gustul ales prin ?gust= — deschidem direct pe profilul lui */
  try {
    var _g = (location.search.match(/[?&]gust=([^&]+)/) || [])[1];
    if (_g) {
      _g = decodeURIComponent(_g);
      if (['curated', 'guest', 'blend', 'choco', 'fruit', 'floral', 'body'].indexOf(_g) > -1) filter = _g;
    }
  } catch (e) { /* ignoram */ }
  var openSlot = -1;
  var gift = (MODE === 'gift');   // pe pagina de cadouri cutia e implicita, fara bifa
  var moneyFmt = CFG.money || '{{amount}} lei';

  /* ---------- utilitare ---------- */
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function esc(x) {
    return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' lei';
  }
  function priceOf(e) { return (ITEMS[e.i].p || [0, 0, 0])[e.g] || 0; }
  /* ---------- transfer intre pagini (?p=id,id,...) ---------- */
  function packParam() {
    var out = [];
    pack.forEach(function (e) { var v = variantOf(e); if (v) out.push(v); });
    return out.join(',');
  }
  function packFromParam(raw) {
    var out = [];
    String(raw || '').split(',').forEach(function (tok) {
      var vid = tok.trim();
      if (!vid || out.length >= SLOTS) return;
      /* cautam in matricea normalizata v[gramaj][macinare]; it.vs e golit la initializare */
      for (var i = 0; i < ITEMS.length; i++) {
        var vv = ITEMS[i].v || [];
        for (var g = 0; g < vv.length; g++) {
          var row = vv[g] || [];
          for (var m = 0; m < row.length; m++) {
            if (row[m] && String(row[m]) === vid) { out.push({ i: i, g: g, m: m }); return; }
          }
        }
      }
    });
    return out;
  }

  function variantOf(e) {
    var v = ITEMS[e.i].v || [];
    return (v[e.g] || [])[e.m] || null;
  }

  /* ---------- filtre ---------- */
  var TASTE = {
    choco: ['ciocolat', 'nuc', 'caramel', 'alun', 'toffee', 'cacao', 'zahăr brun', 'arahid', 'nougat'],
    fruit: ['fruct', 'cireș', 'căpșun', 'zmeur', 'portocal', 'citric', 'grapefruit', 'mandarin', 'prun', 'măr', 'pepene', 'piers', 'stafid'],
    floral: ['iasomie', 'floral', 'bergamot', 'violet', 'ceai', 'salvie', 'vanilie'],
    body: ['cedru', 'condiment', 'pământ', 'tutun', 'lemn', 'ceai negru']
  };
  function matches(it) {
    if (filter === 'all') return true;
    if (filter === 'curated' || filter === 'guest' || filter === 'blend') return it.grp === filter;
    if (filter === 'decaf') return /decaf|cofein/i.test((it.n || []).join(' ') + ' ' + (it.best || '') + ' ' + it.t);
    var kws = TASTE[filter];
    if (!kws) return true;
    var hay = ((it.n || []).join(' ') + ' ' + (it.best || '')).toLowerCase();
    for (var i = 0; i < kws.length; i++) if (hay.indexOf(kws[i]) > -1) return true;
    return false;
  }
  function countOf(idx) {
    var n = 0;
    for (var i = 0; i < pack.length; i++) if (pack[i].i === idx) n++;
    return n;
  }

  /* ---------- catalog ---------- */
  var catEl = $('[data-fsp-cat]');
  function renderCat() {
    var html = '', shown = 0;
    for (var i = 0; i < ITEMS.length; i++) {
      var it = ITEMS[i];
      if (!matches(it)) continue;
      shown++;
      var c = countOf(i);
      var notes = (it.n || []).slice(0, 3).map(function (n) {
        return '<span class="fsp__note">' + esc(n) + '</span>';
      }).join('');
      var badge = it.grp === 'guest' ? 'Guest Star' : (it.grp === 'blend' ? 'Blend' : '');
      html += '<button type="button" class="fsp__card" data-pick="' + i + '" data-picked="' + (c ? 1 : 0) + '"' +
        ' aria-label="' + esc(it.t + ' — adaugă în cutie') + '">' +
        '<span class="fsp__cardImgWrap">' +
        (badge ? '<span class="fsp__badge">' + badge + '</span>' : '') +
        (c ? '<span class="fsp__count" aria-hidden="true">' + c + '</span>' : '') +
        (it.img ? '<img class="fsp__cardImg" src="' + esc(it.img) + '" alt="" loading="lazy" width="320" height="320">' : '') +
        '</span>' +
        '<span class="fsp__cardBody">' +
        '<span class="fsp__cardName">' + esc(it.t) + '</span>' +
        '<span class="fsp__cardOrigin">' + esc(it.o || '') + (it.reg ? ' · ' + esc(it.reg) : '') + '</span>' +
        '<span class="fsp__cardNotes">' + notes + '</span>' +
        '<span class="fsp__cardFoot"><span class="fsp__cardPrice">' + money((it.p || [])[gGram] || 0) + '</span>' +
        '<span class="fsp__cardAdd">' + (pack.length >= SLOTS ? 'Cutia e plină' : 'Adaugă') + '</span></span>' +
        '</span></button>';
    }
    if (!shown) html = '<p class="fsp__empty">Nicio cafea pe filtrul ăsta. Încearcă altul.</p>';
    catEl.innerHTML = html;
  }

  /* actualizare in-place: nu redesenam catalogul la fiecare click (fara flicker de imagini) */
  function updateCat() {
    var full = pack.length >= SLOTS;
    $$('[data-pick]', catEl).forEach(function (el) {
      var i = +el.getAttribute('data-pick'), c = countOf(i);
      el.setAttribute('data-picked', c ? '1' : '0');
      var wrap = el.querySelector('.fsp__cardImgWrap');
      var badge = el.querySelector('.fsp__count');
      if (c && !badge && wrap) {
        badge = document.createElement('span');
        badge.className = 'fsp__count';
        badge.setAttribute('aria-hidden', 'true');
        wrap.appendChild(badge);
      }
      if (badge) {
        if (c) badge.textContent = c; else badge.remove();
      }
      var add = el.querySelector('.fsp__cardAdd');
      if (add) add.textContent = full ? 'Cutia e plină' : 'Adaugă';
      var pr = el.querySelector('.fsp__cardPrice');
      if (pr) pr.textContent = money((ITEMS[i].p || [])[gGram] || 0);
    });
  }

  /* ---------- sloturi ---------- */
  var slotsEl = $('[data-fsp-slots]');
  function renderSlots() {
    var html = '';
    for (var s = 0; s < SLOTS; s++) {
      var e = pack[s];
      var it = e ? ITEMS[e.i] : null;
      html += '<div class="fsp__slot" data-slot="' + s + '" data-filled="' + (e ? 1 : 0) + '">' +
        (e ? '<button type="button" class="fsp__rm" data-rm="' + s + '" aria-label="Scoate ' + esc(it.t) + ' din cutie">×</button>' : '') +
        '<div class="fsp__slotIn">' +
        '<div class="fsp__face fsp__back" aria-hidden="' + (e ? 'true' : 'false') + '">' + (s + 1) + '</div>' +
        '<div class="fsp__face fsp__front">' +
        (it && it.img ? '<img class="fsp__frontImg" src="' + esc(it.img) + '" alt="" width="180" height="240">' : '') +
        (it ? '<span class="fsp__frontCap">' + esc(it.t) + '<br>' + esc(GRAMS[e.g] || '') + '</span>' : '') +
        '</div></div>' +
        (e ? '<button type="button" class="fsp__sr" data-edit="' + s + '">Schimbă opțiunile pentru ' + esc(it.t) + '</button>' : '') +
        '</div>';
    }
    slotsEl.innerHTML = html;
    // click pe cardul întors = editează
    $$('[data-slot]', slotsEl).forEach(function (el) {
      if (el.getAttribute('data-filled') !== '1') return;
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-rm]')) return;
        editSlot(+el.getAttribute('data-slot'));
      });
    });
  }

  /* ---------- clasificare ---------- */
  function classify() {
    var origins = {}, grps = {}, sw = 0, ac = 0, bd = 0, sca = 0, nsca = 0, esp = 0;
    pack.forEach(function (e) {
      var it = ITEMS[e.i];
      origins[it.o || '?'] = 1;
      grps[it.grp || '?'] = (grps[it.grp] || 0) + 1;
      sw += it.sw || 0; ac += it.ac || 0; bd += it.bd || 0;
      if (it.sca) { sca += it.sca; nsca++; }
      if (/espresso|automat/i.test(it.best || '')) esp++;
    });
    var nOrig = Object.keys(origins).length, n = pack.length || 1;
    sw /= n; ac /= n; bd /= n;
    var avgSca = nsca ? (sca / nsca) : 0;
    var guest = grps.guest || 0, blend = grps.blend || 0;

    var r;
    if (nOrig >= 5) r = ['Cartograful', 'Cinci origini diferite într-o singură cutie. Ai construit o hartă, nu un pachet.'];
    else if (guest >= 3) r = ['Vânătorul de raritate', 'Trei sau mai multe Guest Star. Cauți loturile care nu se mai repetă.'];
    else if (blend >= 3) r = ['Arhitectul', 'Mizezi pe blenduri — pe rețetă și consistență, nu pe accident.'];
    else if (esp >= 4) r = ['Constructorul de espresso', 'Cutia ta e calibrată pentru presiune: patru din șase strălucesc sub 9 bari.'];
    else if (ac >= 4 && bd <= 3) r = ['Puristul', 'Aciditate mare, corp lejer. Bei cafea ca să guști terroir-ul, nu ca să te trezești.'];
    else if (bd >= 4 && ac <= 2.5) r = ['Fondatorul', 'Corp dens, aciditate mică. Cafea care ține de foame.'];
    else if (sw >= 4) r = ['Dulcele trai', 'Dulceață peste medie în toate cele șase. Nu-ți trebuie zahăr.'];
    else if (avgSca >= 86) r = ['Colecționarul', 'Scor mediu ' + avgSca.toFixed(1) + ' SCA. Ai ales cu capul, nu cu eticheta.'];
    else r = ['Exploratorul', 'Un echilibru bun între cunoscut și necunoscut. Exact ce face un pachet de degustare.'];
    return r;
  }

  /* ---------- total + stare ---------- */
  var HINTS = [
    'Cutia e goală. Alege prima cafea din stânga.',
    'Un început bun. Mai ai cinci locuri.',
    'Două din șase. Amestecă originile — merită.',
    'Jumătate de drum.',
    'Patru. Mai sunt două până la reducere.',
    'Încă una și se deschide reducerea de ' + D1 + '%.',
    'Cutia e completă.'
  ];
  function tier() {
    if (pack.length < SLOTS) return 0;
    var all500 = pack.every(function (e) { return e.g === G500; });
    return all500 ? 2 : 1;
  }
  function subtotal() {
    var t = 0;
    pack.forEach(function (e) { t += priceOf(e); });
    return t;
  }
  function render() {
    var sub = subtotal(), tr = tier();
    var pct = tr === 2 ? D2 : (tr === 1 ? D1 : 0);
    var save = Math.round(sub * pct / 100);
    var boxCost = (gift && BOX) ? (+BOX.price || 0) : 0;
    var tot = sub - save + boxCost;

    var boxRow = $('[data-fsp-boxrow]');
    if (boxRow) {
      boxRow.hidden = !boxCost;
      if (boxCost) $('[data-fsp-boxprice]').textContent = '+' + money(boxCost);
    }

    $('[data-fsp-n]').textContent = pack.length + '/' + SLOTS;
    var dots = $$('[data-dot]');
    if (dots.length !== SLOTS) {
      var dw = dots.length ? dots[0].parentNode : null;
      if (dw) {
        dw.innerHTML = new Array(SLOTS + 1).join('<span class="fsp__dot" data-dot></span>');
        dots = $$('[data-dot]');
      }
    }
    dots.forEach(function (d, i) { d.classList.toggle('on', i < pack.length); });
    $('[data-fsp-hint]').textContent = HINTS[Math.min(pack.length, SLOTS)];

    $('[data-fsp-sub]').textContent = money(sub);
    var saveRow = $('[data-fsp-saverow]');
    saveRow.hidden = !save;
    if (save) $('[data-fsp-save]').textContent = '−' + money(save) + ' (' + pct + '%)';
    $('[data-fsp-total]').innerHTML = (save ? '<span class="fsp__was">' + money(sub + boxCost) + '</span>' : '') + money(tot);

    // upsell 500 g
    var up = $('[data-fsp-upsell]');
    if (tr === 1) {
      var alt = 0;
      pack.forEach(function (e) { alt += (ITEMS[e.i].p || [])[G500] || 0; });
      var altSave = Math.round(alt * D2 / 100);
      var gain = (alt - altSave + boxCost) - tot;
      $('[data-fsp-upsellP]').textContent = gain > 0
        ? 'Treci toate șase la 500 g: plătești ' + money(alt - altSave + boxCost) + ' (+' + money(gain) + ') pentru dublul cantității și reducerea urcă la ' + D2 + '%.'
        : 'Treci toate șase la 500 g și reducerea urcă la ' + D2 + '%.';
      up.classList.add('on');
    } else up.classList.remove('on');

    // diplomă
    var dip = $('[data-fsp-dip]');
    if (pack.length === SLOTS) {
      var c = classify();
      $('[data-fsp-dipT]').textContent = c[0];
      $('[data-fsp-dipP]').textContent = c[1];
      dip.classList.add('on');
    } else dip.classList.remove('on');

    var btn = $('[data-fsp-add]');
    btn.disabled = pack.length !== SLOTS;
    btn.textContent = pack.length === SLOTS
      ? (gift ? 'Adaugă cadoul în coș · ' : 'Adaugă cutia în coș · ') + money(tot)
      : 'Mai alege ' + (SLOTS - pack.length) + (SLOTS - pack.length === 1 ? ' cafea' : ' cafele');

    var gl = $('[data-fsp-giftlink]');
    if (gl) {
      var base = gl.getAttribute('data-href');
      if (base === null) { base = gl.getAttribute('href') || ''; gl.setAttribute('data-href', base); }
      var pp = packParam();
      gl.setAttribute('href', pp ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'p=' + pp : base);
    }

    var bar = $('[data-fsp-bar]');
    bar.classList.toggle('on', pack.length > 0);
    $('[data-fsp-barN]').textContent = pack.length + ' din ' + SLOTS + ' alese';
    $('[data-fsp-barV]').textContent = money(tot);

    $$('[data-fsp-seg]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(+b.getAttribute('data-fsp-seg') === gGram));
    });
    $('[data-fsp-grind]').value = String(gGrind);
    renderSlots();
    updateCat();
  }

  /* ---------- cadou ----------
     Detaliile stau ca proprietati pe linia cutiei, nu ca atribute de cos:
     asa o comanda care are si un pachet pentru client, si unul cadou,
     nu amesteca informatiile intre ele. */
  function giftVal(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
  function boxProps(stamp) {
    var p = { 'Pachet': 'The Sixt Pack', '_pack_id': stamp, 'Cadou': 'da' };
    var to = giftVal('fsp-gift-to'); if (to) p['Pentru'] = to;
    var ms = giftVal('fsp-gift-msg'); if (ms) p['Mesaj'] = ms;
    var dt = giftVal('fsp-gift-date'); if (dt) p['Data dorită'] = dt;
    var noInv = document.getElementById('fsp-gift-noinv');
    p['Fără factură în cutie'] = (noInv && noInv.checked) ? 'da' : 'nu';
    return p;
  }

  /* ---------- acțiuni ---------- */
  function add(idx) {
    if (pack.length >= SLOTS) { flash('Cutia are doar ' + SLOTS + ' locuri. Scoate una ca să adaugi alta.'); return; }
    pack.push({ i: idx, g: gGram, m: gGrind });
    render();
    announce(ITEMS[idx].t + ' adăugată. ' + pack.length + ' din ' + SLOTS + '.');
  }
  function flash(msg) { $('[data-fsp-hint]').textContent = msg; }
  function announce(msg) { $('[data-fsp-live]').textContent = msg; }

  /* ---------- modal ---------- */
  var mask = $('[data-fsp-mask]'), modal = $('[data-fsp-modal]'), lastFocus = null;
  function openModal(html) {
    lastFocus = document.activeElement;
    modal.innerHTML = html;
    mask.classList.add('on');
    document.body.style.overflow = 'hidden';
    var f = modal.querySelector('button, select');
    if (f) f.focus();
  }
  function closeModal() {
    mask.classList.remove('on');
    document.body.style.overflow = '';
    openSlot = -1;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  mask.addEventListener('click', function (e) { if (e.target === mask) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mask.classList.contains('on')) closeModal(); });

  function editSlot(s) {
    openSlot = s;
    var e = pack[s]; if (!e) return;
    var it = ITEMS[e.i];
    var gs = GRAMS.map(function (g, gi) {
      return '<button type="button" class="fsp__segBtn" data-eg="' + gi + '" aria-pressed="' + (gi === e.g) + '">' + esc(g) + '</button>';
    }).join('');
    var ms = GRINDS.map(function (m, mi) {
      return '<option value="' + mi + '"' + (mi === e.m ? ' selected' : '') + '>' + esc(m) + (mi === GBEANS ? ' — recomandat' : '') + '</option>';
    }).join('');
    openModal(
      '<h3 class="fsp__modalT">' + esc(it.t) + '</h3>' +
      '<p class="fsp__modalP">' + esc(it.o || '') + (it.reg ? ' · ' + esc(it.reg) : '') + (it.roast ? ' · ' + esc(it.roast) : '') + '</p>' +
      '<div class="fsp__opt"><span class="fsp__optL">Gramaj</span><div class="fsp__seg">' + gs + '</div></div>' +
      '<div class="fsp__opt"><span class="fsp__optL">Grad de măcinare</span>' +
      '<select class="fsp__sel" data-em>' + ms + '</select>' +
      '<p class="fsp__tip">Boabele întregi își păstrează aroma 3–4 săptămâni. Măcinată, cafeaua pierde cea mai mare parte din arome în 7–10 zile.</p></div>' +
      '<button type="button" class="fsp__btn fsp__btn--ghost" data-remove>Scoate din cutie</button>' +
      '<button type="button" class="fsp__close" data-close>Gata</button>'
    );
  }

  /* ---------- alege tu pentru mine ---------- */
  var QS = [
    { k: 'method', q: 'Cum îți prepari cafeaua cel mai des?', o: [
      ['espresso', 'Espresso manual', 'Portafiltru'],
      ['automat', 'Espressor automat', 'Bean-to-cup'],
      ['filtru', 'Filtru / V60', 'Pour-over, AeroPress'],
      ['moka', 'Moka / ibric', 'Dens, concentrat'],
      ['press', 'French Press / Cold Brew', 'Imersie']
    ] },
    { k: 'taste', q: 'Ce gust te face să revii la ceașcă?', o: [
      ['choco', 'Ciocolată și nuci', 'Cald, dulce'],
      ['fruit', 'Fructat și vibrant', 'Fructe roșii, citrice'],
      ['floral', 'Floral și delicat', 'Iasomie, bergamotă'],
      ['body', 'Corp plin, intens', 'Dens, fără aciditate']
    ] },
    { k: 'mood', q: 'Cât de departe vrei să mergi?', o: [
      ['safe', 'Pe sigur', 'Cafele care nu dau greș'],
      ['mixed', 'Echilibrat', 'Jumătate cunoscut, jumătate nou'],
      ['wild', 'Surprinde-mă', 'Vreau loturile ciudate']
    ] }
  ];
  var ans = {}, qi = 0;

  function startWizard() { ans = {}; qi = 0; showQ(); }
  function showQ() {
    if (qi >= QS.length) { closeModal(); autofill(); return; }
    var Q = QS[qi];
    openModal(
      '<h3 class="fsp__modalT">' + esc(Q.q) + '</h3>' +
      '<p class="fsp__modalP">Întrebarea ' + (qi + 1) + ' din ' + QS.length + '. Pe baza răspunsurilor umplu toate cele ' + SLOTS + ' locuri.</p>' +
      '<div class="fsp__qs">' + Q.o.map(function (o) {
        return '<button type="button" class="fsp__q" data-a="' + o[0] + '"><span class="fsp__qT">' + esc(o[1]) + '</span><span class="fsp__qS">' + esc(o[2]) + '</span></button>';
      }).join('') + '</div>' +
      '<button type="button" class="fsp__close" data-close>Renunț</button>'
    );
  }
  function score(it) {
    var s = 0, best = (it.best || '').toLowerCase();
    var notes = ((it.n || []).join(' ') + ' ' + best).toLowerCase();
    var m = ans.method;
    if (m === 'espresso' && /espresso/.test(best)) s += 3;
    if (m === 'automat') { if ((it.mach || 0) >= 18) s += 3; else if ((it.mach || 0) >= 14) s += 2; if (/automat/.test(best)) s += 1; }
    if (m === 'filtru' && /(filtru|v60|aeropress|chemex|pour)/.test(best)) s += 3;
    if (m === 'moka' && /(moka|ibric)/.test(best)) s += 3;
    if (m === 'press' && /(french press|cold brew|imersie)/.test(best)) s += 3;
    var kws = TASTE[ans.taste] || [], hit = 0;
    for (var i = 0; i < kws.length; i++) if (notes.indexOf(kws[i]) > -1) hit++;
    s += Math.min(hit, 3) * 2;
    if (ans.taste === 'choco' && (it.sw || 0) >= 4) s += 1;
    if (ans.taste === 'fruit' && (it.ac || 0) >= 4) s += 1;
    if (ans.taste === 'floral' && (it.ac || 0) >= 4 && (it.bd || 0) <= 3) s += 1;
    if (ans.taste === 'body') { s += ((it.bd || 0) - 3); if ((it.ac || 0) <= 2) s += 2; }
    if (ans.mood === 'safe' && it.grp !== 'guest') s += 2;
    if (ans.mood === 'wild' && it.grp === 'guest') s += 3;
    if (ans.mood === 'mixed' && it.grp === 'guest') s += 1;
    if (it.sca) s += (it.sca - 84) * .4;
    return s;
  }
  function autofill() {
    var ranked = ITEMS.map(function (it, i) { return { i: i, s: score(it), o: it.o || '?' }; })
      .sort(function (a, b) { return b.s - a.s; });
    var picked = [], perOrigin = {};
    for (var pass = 1; pass <= 3 && picked.length < SLOTS; pass++) {
      for (var k = 0; k < ranked.length && picked.length < SLOTS; k++) {
        var r = ranked[k];
        if (picked.indexOf(r.i) > -1) continue;
        if ((perOrigin[r.o] || 0) >= pass) continue;
        perOrigin[r.o] = (perOrigin[r.o] || 0) + 1;
        picked.push(r.i);
      }
    }
    pack = [];
    render();
    picked.forEach(function (idx, n) {
      setTimeout(function () {
        pack.push({ i: idx, g: gGram, m: gGrind });
        render();
        if (n === picked.length - 1) announce('Cutia a fost completată automat cu ' + picked.length + ' cafele.');
      }, n * 190);
    });
  }

  /* ---------- adaugă în coș ---------- */
  function addToCart() {
    if (pack.length !== SLOTS) return;
    var btn = $('[data-fsp-add]');
    btn.disabled = true; btn.textContent = 'Se adaugă…';
    var stamp = 'SP-' + Date.now().toString(36).toUpperCase();
    var items = pack.map(function (e, n) {
      var vid = variantOf(e);
      return {
        id: vid, quantity: 1,
        properties: {
          'Pachet': 'The Sixt Pack',
          'Măcinare': GRINDS[e.m] || '',
          '_pack_id': stamp,
          '_pack_pos': String(n + 1)
        }
      };
    });
    if (gift && BOX && BOX.id) {
      items.push({ id: BOX.id, quantity: 1, properties: boxProps(stamp) });
    }
    if (items.some(function (x) { return !x.id; })) {
      btn.disabled = false; render();
      flash('O variantă nu a putut fi identificată. Reîncarcă pagina și încearcă din nou.');
      return;
    }
    var code = tier() === 2 ? C2 : C1;
    var J = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

    /* Codurile de pachet rămân lipite de sesiune. Dacă unul dintre ele e deja
       în coș, îl curățăm întâi, altfel cel vechi îl blochează pe cel corect
       (nu se combină între ele) și clientul ia procentul greșit. */
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var mine = (c.discount_codes || []).some(function (d) {
          return d && (d.code === C1 || d.code === C2);
        });
        if (!mine) return null;
        return fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ discount: '' }) });
      })
      .catch(function () { return null; })
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: items }) });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = code
          ? '/discount/' + encodeURIComponent(code) + '?redirect=/cart'
          : '/cart';
      })
      .catch(function () {
        btn.disabled = false; render();
        flash('Nu am putut adăuga în coș. Verifică conexiunea și încearcă din nou.');
      });
  }

  /* ---------- evenimente ---------- */
  root.addEventListener('click', function (ev) {
    var t = ev.target;
    var el;
    if ((el = t.closest('[data-pick]'))) { add(+el.getAttribute('data-pick')); return; }
    if ((el = t.closest('[data-rm]'))) { ev.stopPropagation(); pack.splice(+el.getAttribute('data-rm'), 1); render(); return; }
    if ((el = t.closest('[data-edit]'))) { editSlot(+el.getAttribute('data-edit')); return; }
    if ((el = t.closest('[data-fsp-filter]'))) {
      filter = el.getAttribute('data-fsp-filter');
      $$('[data-fsp-filter]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === el)); });
      renderCat(); return;
    }
    if ((el = t.closest('[data-fsp-seg]'))) {
      gGram = +el.getAttribute('data-fsp-seg');
      pack.forEach(function (e) { e.g = gGram; });
      render(); return;
    }
    if (t.closest('[data-fsp-all500]')) {
      gGram = G500; pack.forEach(function (e) { e.g = G500; }); render();
      announce('Toate cele șase au fost trecute la 500 g. Reducere ' + D2 + '%.'); return;
    }
    if (t.closest('[data-fsp-wizard]')) { startWizard(); return; }
    if (t.closest('[data-fsp-reset]')) { pack = []; render(); return; }
    if (t.closest('[data-fsp-add]')) { addToCart(); return; }
    if (t.closest('[data-fsp-goto]')) {
      var box = $('[data-fsp-box]');
      if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
  });

  root.addEventListener('input', function (ev) {
    if (ev.target && ev.target.id === 'fsp-gift-msg') {
      var cnt = $('[data-fsp-cnt]');
      if (cnt) cnt.textContent = ev.target.value.length + ' / 200';
    }
  });

  root.addEventListener('change', function (ev) {
    if (ev.target.hasAttribute('data-fsp-grind')) {
      gGrind = +ev.target.value;
      pack.forEach(function (e) { e.m = gGrind; });
      render();
    }
  });

  modal.addEventListener('click', function (ev) {
    var t = ev.target, el;
    if (t.closest('[data-close]')) { closeModal(); return; }
    if ((el = t.closest('[data-a]'))) {
      ans[QS[qi].k] = el.getAttribute('data-a'); qi++; showQ(); return;
    }
    if ((el = t.closest('[data-eg]')) && pack[openSlot]) {
      pack[openSlot].g = +el.getAttribute('data-eg');
      $$('[data-eg]', modal).forEach(function (b) { b.setAttribute('aria-pressed', String(b === el)); });
      render(); return;
    }
    if (t.closest('[data-remove]') && openSlot > -1) {
      pack.splice(openSlot, 1); closeModal(); render(); return;
    }
  });
  modal.addEventListener('change', function (ev) {
    if (ev.target.hasAttribute('data-em') && pack[openSlot]) {
      pack[openSlot].m = +ev.target.value; render();
    }
  });

  try {
    var _p = new URLSearchParams(window.location.search).get('p');
    if (_p) {
      var _restored = packFromParam(_p);
      if (_restored.length) { pack = _restored; gGram = pack[0].g; gGrind = pack[0].m; }
    }
  } catch (e) { /* ignoram */ }

  $$('[data-fsp-filter]').forEach(function (b) {
    b.setAttribute('aria-pressed', String(b.getAttribute('data-fsp-filter') === filter));
  });
  renderCat();
  render();
})();
